import { Component, Inject, OnInit } from "@angular/core";
import { APP_CONFIG, IAppConfig } from "./app.config";

import { HttpClient  } from '@angular/common/http';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit{
  portName: any;
  constructor( private http:HttpClient, @Inject(APP_CONFIG) private config: IAppConfig,) {
     }
  title = "Vee-Lcs";

  
  ngOnInit() 
  {

  }
}
